export const heroHighlights = [
  { icon: "ri-shield-check-line", label: "100% Safe & Insured" },
  { icon: "ri-timer-flash-line", label: "On-Time Delivery" },
  { icon: "ri-price-tag-3-line", label: "No Hidden Costs" },
];

export const aboutCards = [
  {
    title: "#1 Office Shifting Services Bangalore | Best Offers Assured",
    description:
      "Office Shifting Services Bangalore – professional, fast and efficient removal service for your business.",
    image:
      "/uploads/about-office-shifting.jpeg",
    href: "/services/office-shifting",
  },
  {
    title: "House Shifting Services in Bangalore | Great Offers, 24×7 Service",
    description:
      "Lahari Packers and Movers is among the top house shifting service providers in Bangalore, moving everything from a single item to a complete large household.",
    image:
      "/uploads/about-house-shifting.jpeg",
    href: "/services/house-shifting",
  },
  {
    title: "Storage service in Bangalore",
    description:
      "Lahari Packers and Movers offers packaging and own warehouse storage service in Bangalore.",
    image:
      "/uploads/about-storage.jpeg",
    href: "/services/storage",
  },
];

export interface HomeService {
  icon: string;
  title: string;
  description: string;
  href?: string;
  featured?: boolean;
}

export const services: HomeService[] = [
  {
    icon: "ri-archive-2-line",
    title: "PACKAGING & UNPACKING",
    description:
      "Careful preparation of your goods for safe storage and moving — including cushioning, sealing, strapping, weatherproofing and wrapping.",
  },
  {
    icon: "ri-truck-line",
    title: "LOCAL SHIFTING",
    href: "/services/local-shifting",
    featured: true,
    description:
      "Fast, same-city shifting across every locality in Bangalore, with short acceptance times at pickup and top loading and delivery priority at your destination.",
  },
  {
    icon: "ri-building-2-line",
    title: "COMMERCIAL MOVERS",
    href: "/services/office-shifting",
    description:
      "We take care of the commercial goods side of your business, handling office and interstate moves from one place to anywhere within Bangalore.",
  },
  {
    icon: "ri-home-4-line",
    title: "HOUSE SHIFTING",
    href: "/services/house-shifting",
    description:
      "Our staff are well trained in careful packing, moving and unpacking, right through to your final new destination.",
  },
  {
    icon: "ri-shield-star-line",
    title: "VALUABLE MOVES",
    description:
      "Dedicated, extra-care handling for your most valuable items. We arrange the paperwork and coordination needed for high-value goods so everything moves safely and smoothly.",
  },
  {
    icon: "ri-store-3-line",
    title: "STORAGE FACILITY",
    href: "/services/storage",
    description:
      "We provide our customers with modern, spacious and secure warehousing options at our hub to meet their unique needs. Our facilities include cold rooms as well as general warehouses.",
  },
];

export const stats = [
  { icon: "ri-emotion-happy-line", value: 1780, suffix: "+", label: "Happy Clients" },
  { icon: "ri-team-line", value: 10, suffix: "", label: "Active Workers" },
  { icon: "ri-award-line", value: 20, suffix: "+", label: "Years of Experience" },
  { icon: "ri-file-list-3-line", value: 500, suffix: "+", label: "Moves Completed" },
  { icon: "ri-customer-service-2-line", value: 24, suffix: "×7", label: "Support Helpline" },
];

export const testimonials = [
  {
    quote:
      "Your team was highly efficient and energetic throughout the entire process. My goods were moved from Bangalore to Mysore without any damages. Will definitely recommend Lahari Packers and Movers. They wrapped, packed and unpacked my entire move. I was highly impressed with their service. Best moving company in Bangalore. Highly recommended.",
    name: "Sujata Khanal",
    company: "Codewing Solutions",
    image:
      "/uploads/reviewer-sujata.jpeg",
  },
  {
    quote:
      "Thank you so much for your swift moving services that you guys assisted moving my goods from Bangalore to Tumkur. You guys were quick and professional and my goods were in my new home within no time. Will contact you for my next move.",
    name: "Ankit Jain",
    company: "Codewing Solutions",
    image:
      "/uploads/reviewer-ankit.jpeg",
  },
  {
    quote:
      "Thank you for your amazing services over the past weekend. Firstly, you guys were by far the best price for the job and then even provided services of the highest level. I was impressed with the services I received from you and your men on the day. My furniture was in my new place in no time and was handled with the utmost care the entire time. Thank you.",
    name: "Govardhan Sharma",
    company: "Codewing Solutions",
    image:
      "/uploads/reviewer-govardhan.jpeg",
  },
];

export const visionMission = [
  {
    icon: "ri-eye-line",
    image:
      "/uploads/vision-icon.png",
    title: "Our Vision",
    text: "To provide the best packing and moving services by hard work and hence earn friendliness of customers through quality services.",
  },
  {
    icon: "ri-flag-2-line",
    image:
      "/uploads/mission-icon.png",
    title: "Our Mission",
    text: "It is our mission to be the preferred packaging and moving company to our clientele by offering a reliable, professional and efficient service at an affordable price.",
  },
  {
    icon: "ri-heart-3-line",
    image: "",
    title: "Our Core Values",
    text: "Safety, transparency and respect for every customer's belongings. We treat each move as if it were our own, with trained staff, quality packing material and honest pricing.",
  },
];

export const whyChooseUs = [
  { icon: "ri-user-star-line", title: "Trained Professionals", text: "Skilled, uniformed staff trained for packing, loading and safe handling of fragile goods." },
  { icon: "ri-box-3-line", title: "Quality Packing Material", text: "Premium bubble wrap, foam, cartons and wooden crates to protect every item." },
  { icon: "ri-route-line", title: "All Bangalore Zones", text: "Service across Nagarabhavi, Rajajinagar, Malleshwaram, Whitefield, HSR and more." },
  { icon: "ri-hand-coin-line", title: "Transparent Pricing", text: "Best prices with no hidden costs. Get a clear estimate before the move begins." },
  { icon: "ri-customer-service-line", title: "24×7 Support", text: "Dedicated helpline to track your belongings at every stage of the move." },
  { icon: "ri-map-pin-2-line", title: "Bangalore • Mysore • Tumkur", text: "Reliable intercity and local shifting across Karnataka with on-time delivery." },
];

export const processSteps = [
  { icon: "ri-chat-1-line", title: "Get a Free Quote", text: "Share your move details and receive a transparent estimate within minutes." },
  { icon: "ri-calendar-check-line", title: "Schedule the Move", text: "Pick a convenient date. Our team arrives on time with all packing material." },
  { icon: "ri-archive-2-line", title: "Pack & Load", text: "Items are professionally packed, labelled and loaded with utmost care." },
  { icon: "ri-truck-line", title: "Safe Delivery", text: "We move and unload, then unpack and arrange at your new destination." },
];